export enum TenantStatus {
  Unknown = 0,
  Active = 1,
  Inactive = 2,
  Invited = 3,
  Suspended = 4,
}

/** Shape returned by GET /tenants */
export interface TenantApiDto {
  id: number;
  clinicName: string;
  customerKey: string;
  email: string;
  phoneNumber: string;
  ownerFirstName: string;
  ownerLastName: string;
  status: number;
  createdAt: string;
  updatedAt: string;
}

/** UI model used across the app */
export interface Tenant {
  id: string;
  clinicName: string;
  customerKey: string;
  status: TenantStatus;
  createdDate: string;
  lastUpdated: string;
  contactName: string;
  contactEmail: string;
  phoneNumber: string;
}

/** Maps a TenantStatus enum value to the CSS status key used by StatusBadge */
export function getTenantStatusKey(status: TenantStatus): string {
  switch (status) {
    case TenantStatus.Active:
      return "active";
    case TenantStatus.Inactive:
      return "inactive";
    case TenantStatus.Invited:
      return "pending-activation";
    case TenantStatus.Suspended:
      return "suspended";
    default:
      return "unknown";
  }
}

/** Maps a raw API DTO to the UI Tenant model */
export function mapTenantFromApi(dto: TenantApiDto): Tenant {
  return {
    id: String(dto.id),
    clinicName: dto.clinicName,
    customerKey: dto.customerKey,
    status: dto.status as TenantStatus,
    createdDate: dto.createdAt ? dto.createdAt.split("T")[0] : "",
    lastUpdated: dto.updatedAt ? dto.updatedAt.split("T")[0] : "",
    contactName: [dto.ownerFirstName, dto.ownerLastName].filter(Boolean).join(" "),
    contactEmail: dto.email,
    phoneNumber: dto.phoneNumber,
  };
}
